import script from "./CustomButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomButton.vue?vue&type=script&setup=true&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=5e7e689d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7e689d"]])

export default __exports__